var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadtabillustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 726,
    viewBox: "0 0 1920 726",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1920,
    height: 726
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 726,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.716 216C238.899 216 284.444 169.885 284.444 113C284.444 56.1147 238.899 10 182.716 10C126.533 10 80.9875 56.1147 80.9875 113C80.9875 169.885 126.533 216 182.716 216Z",
    fill: "#FE8083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1817.28 308C1850.56 308 1877.53 280.689 1877.53 247C1877.53 213.311 1850.56 186 1817.28 186C1784.01 186 1757.04 213.311 1757.04 247C1757.04 280.689 1784.01 308 1817.28 308Z",
    fill: "#FE8083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199 637.441C199 637.441 444.252 160.655 933.109 266.272C1421.97 371.889 1612.08 658.564 2022.48 456.383C2432.87 254.202 2487.19 377.925 2487.19 377.925V637.442L199 637.441Z",
    fill: "#1D85E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-258.765 640.441C-258.765 640.441 -16.5408 163.655 466.281 269.272C949.103 374.889 1136.87 661.564 1542.2 459.383C1947.53 257.202 2270.18 459.383 2270.18 459.383L2001.18 640.441H-258.765Z",
    fill: "#FE8083"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1722.52 565C1722.52 600.943 1708.42 635.415 1683.31 660.831C1658.21 686.246 1624.17 700.525 1588.67 700.525C1553.17 700.525 1519.12 686.246 1494.02 660.831C1468.92 635.415 1454.81 600.943 1454.81 565H1722.52Z",
    fill: "#FFC258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.156 712.495L187.215 580L51.3579 606.738L142.156 712.495Z",
    fill: "#2DC8A8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadtabillustration);
export default __webpack_public_path__ + "static/media/Download tab illustration.9f65562e6ed161fef8d60a5e7756f711.svg";
export { ForwardRef as ReactComponent };